<div class="wm-studio-issues">
  <div class="tab-header">
    <div class="col-xs-9 no-padding">
      <label class="title" [ngClass]="{'active': issuesService.activeTab === 'inspect'}" (click)="issuesService.activeTab = 'inspect'">{{locale.LABEL_INSPECT}}</label>
      <label class="title" *ngIf="!(preferences.project.actions.inspect && preferences.project.actions.inspect.disable)" [ngClass]="{'active': issuesService.activeTab === 'api-issues'}" (click)="issuesService.activeTab = 'api-issues'">{{locale.LABEL_API_ISSUES}}</label>
    </div>
    <span *ngIf="issuesService.activeTab === 'inspect'">
      <a *ngIf="!codeInspectService.pollStatus.disableBtn" class="wm-icon24 wms wms-download download" target="_blank" title="{{locale.LABEL_DOWNLOAD}}"
         download="{{codeInspectService.download_options.name}}" href="{{codeInspectService.download_options.url + '?download=true'}}"></a>
      <a *ngIf="codeInspectService.pollStatus.disableBtn" class="wm-icon24 wms wms-download download disable-btn" target="_blank" title="{{locale.MESSAGE_INSPECT_REFRESH_PENDING_STATUS}}"></a>
    </span>
    <span>
      <i *ngIf="!codeInspectService.pollStatus.disableBtn" class="wms wms-refresh refresh" (click)="refreshInspect()" title="{{locale.LABEL_REFRESH_CONSOLE}}"></i>
      <i *ngIf="codeInspectService.pollStatus.disableBtn" class="wms wms-refresh refresh disable-btn"  title="{{locale.MESSAGE_INSPECT_REFRESH_PENDING_STATUS}}"></i>
    </span>
    <span><i class="wms wms-close" (click)="closeIssues()" title="{{locale.LABEL_DIALOG_CLOSE}}"></i></span>
  </div>
  <div class="tab-content row">
    <wms-code-inspect *ngIf="issuesService.activeTab === 'inspect'"></wms-code-inspect>
    <wms-api-issues *ngIf="issuesService.activeTab === 'api-issues' && !(preferences.project.actions.inspect && preferences.project.actions.inspect.disable)"></wms-api-issues>
  </div>
</div>
